import MetricImgBox from './MetricImgBox';

export type { MetricBoxProps } from './MetricImgBox';

export default MetricImgBox;
